import { c as _c } from "react/compiler-runtime";
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { ReactElement } from 'react';
import styles from './skip-links.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
const SkipLinksComponent = () => {
  const $ = _c(11);
  const {
    formatMessage
  } = useNamespacedIntl("a11y");
  let t0;
  if ($[0] !== formatMessage) {
    t0 = formatMessage("skipToNavigation");
    $[0] = formatMessage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <a href="#navigation">{t0}</a>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== formatMessage) {
    t2 = formatMessage("skipToMainContent");
    $[4] = formatMessage;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <a href="#main">{t2}</a>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className={styles["skip-links-bar"]}><div className={styles["skip-links-content"]}>{t1}{t3}</div></div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default SkipLinksComponent;